const categoriesReducer = (state = {}, action) => {
  switch (action.type) {
  case 'GET_CATEGORIES':
    if (action.error) return state;
    return { data: action.data.data };

  default:
    return state;
  }
};

export default categoriesReducer;
